<template>
    <v-form :ref="get_step_string">
        <div>
            <h3 class="mb-0">DataStreams</h3>
            <div class="form-group row">
                <div class="col-md-12 p-md-3">
                    <template>
                        <v-container fluid>
                            <span class="d-block mb-3">
                                Click <span class="cursor-pointer text-info font-weight-bold" @click="open_docs">here</span> to see further information.
                            </span>

                            <template>
                                <div class="d-flex justify-content-end">
                                    <div class="d-flex align-center justify-content-end mr-3">
                                        <div class="d-inline-block mb-n2">
                                            <v-switch
                                                color="success"
                                                v-model="export_all"
                                                @change="exportAllDataStreams($event)"
                                                :disabled="visualize_all"
                                                inset
                                            ></v-switch>
                                        </div>
                                        <span class="mr-2 font-weight-bold">Export All</span>
                                    </div>

                                    <div class="d-flex align-center justify-content-end">
                                        <div class="d-inline-block mb-n2">
                                            <v-switch
                                                color="info"
                                                v-model="visualize_all"
                                                @change="visualizeAllDataStreams($event)"
                                                :disabled="export_all"
                                                inset
                                            ></v-switch>
                                        </div>
                                        <span class="mr-2 font-weight-bold">Export & Visualize All</span>
                                    </div>
                                </div>

                                <div class="d-flex align-center justify-content-end">
                                    <span class="text-muted pb-2">Please note that visualizing the results may take additional time to generate the results.</span>
                                </div>

                                <v-expansion-panels
                                    v-if="is_datastreams_available"
                                    :v-model="opened_panels"
                                    :lazy="false"
                                    multiple
                                >
                                    <v-expansion-panel
                                        v-for="(data_stream, ds_index) in $store.getters['ActivateAudienceStore/getDataStreamsOptions']"
                                        :key="ds_index"
                                    >
                                        <v-expansion-panel-header hide-actions>
                                            <div class="d-flex align-center justify-content-between">
                                                <span>{{ data_stream.text }}</span>
                                                <div class="d-inline-block mb-n2">
                                                    <div class="d-flex justify-content-end">
                                                        <div class="d-flex align-center justify-content-end mr-3">
                                                            <div class="d-inline-block mb-n2">
                                                                <v-switch
                                                                    v-if="!data_stream.is_default"
                                                                    :key="ds_index + '_status'"
                                                                    color="success"
                                                                    class="d-inline-block"
                                                                    :value="getDataStreamStatusValue(ds_index)"
                                                                    @change="updateDataStreamStatusValue(ds_index, $event)"
                                                                    inset
                                                                ></v-switch>
                                                                <v-switch
                                                                    v-else
                                                                    color="success"
                                                                    class="d-inline-block"
                                                                    disabled
                                                                    v-model="default_selection"
                                                                    inset
                                                                ></v-switch>
                                                            </div>
                                                            <span class="mr-2">Export</span>
                                                        </div>

                                                        <div class="d-flex align-center justify-content-end">
                                                            <div class="d-inline-block mb-n2">
                                                                <v-switch
                                                                    v-if="data_stream.is_visualizing_available"
                                                                    :key="ds_index + '_vis'"
                                                                    color="info"
                                                                    class="d-inline-block"
                                                                    :disabled="! getDataStreamStatusValue(ds_index)"
                                                                    :value="getDataStreamVisualizingStatusValue(ds_index)"
                                                                    @change="updateDataStreamVisualizingStatusValue(ds_index, $event)"
                                                                    inset
                                                                ></v-switch>
                                                                <v-switch
                                                                    v-else
                                                                    color="info"
                                                                    class="d-inline-block"
                                                                    disabled
                                                                    inset
                                                                ></v-switch>
                                                            </div>
                                                            <span class="mr-2">Visualize</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <div class="row mt-6">
                                                <div class="col-12">
                                                    <span v-html="data_stream.description"></span>
                                                </div>
                                            </div>
                                            <div class="form-group row p-md-2" v-if="partner.id > 0" v-for="(input, input_index) in partner.inputs">
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-md-1 mt-6">
                                                            <Tooltip :text="input.description"></Tooltip>
                                                        </div>
                                                        <div class="col-md-10" v-if="input.type === 'file'">
                                                            <v-file-input
                                                                show-size
                                                                accept="application/json"
                                                                truncate-length="15"
                                                                :label="input.name"
                                                                :value="getDataStreamServiceAccountFile(ds_index)"
                                                                @change="updateDataStreamCredentials(ds_index, $event)"
                                                                :placeholder="input.placeholder"
                                                                :rules="[(input.is_required === '1' && getDataStreamStatusValue(ds_index)) ? requiredFileField : true]"
                                                            ></v-file-input>
                                                        </div><!--col-->
                                                        <div class="col-md-10" v-else>
                                                            <v-text-field
                                                                :key="ds_index + '-' + input_index"
                                                                :value="getDataStreamInputValue(ds_index, input_index)"
                                                                @input="updateDataStreamInputValue(ds_index, input_index, $event)"
                                                                :label="input.name"
                                                                :placeholder="input.placeholder"
                                                                :rules="[
                                                                    (input.is_required === '1' && getDataStreamStatusValue(ds_index)) ? requiredField : true,
                                                                    (input.validation && getDataStreamStatusValue(ds_index)) ? fieldRegexValidation(input.validation, input_index, 'audience') : true,
                                                                    (input.name === 'Folder Prefix' && getDataStreamCustomDeliveryData(ds_index).is_custom_delivery) ? fieldRegexMacrosValidation(ds_index, input_index) : true
                                                                    ]"
                                                            ></v-text-field>

                                                            <small class="text-info" v-if="(input.name === 'Folder Prefix') && getDataStreamCustomDeliveryData(ds_index).is_custom_delivery">
                                                                Available Macros:
                                                                <span v-for="(macro, index) in getDataStreamCustomDeliveryData(ds_index).custom_macros">
                                                                    {<span>{{ macro }}</span>}<span v-if="getDataStreamCustomDeliveryData(ds_index).custom_macros.length - 1 > index">,</span>
                                                                </span>
                                                            </small>

                                                        </div><!--col-->
                                                    </div>
                                                </div>
                                            </div><!--form-group-->
                                            <div class="form-group row">
                                                <div class="col-md-1 mt-6">
                                                    <Tooltip text="You can choose the exported files compression type"></Tooltip>
                                                </div>
                                                <div class="col-md-10">
                                                    <v-select
                                                        :items="partner.compression_types"
                                                        :value="getDataStreamCompressionType(ds_index)"
                                                        @change="updateDataStreamCompressionType(ds_index, $event)"
                                                        label="Compression Type"
                                                        :rules="[requiredField]"
                                                    ></v-select>
                                                </div><!--col-->
                                            </div>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>

                                <div class="row">
                                    <div class="col-12">
                                        <DatastreamsLoading v-if="!is_loading_completed"></DatastreamsLoading>
                                    </div>
                                </div>

                                <div class="row" v-if="is_loading_completed && !is_datastreams_available">
                                    <div class="col-12">
                                        <h5>No datastreams available.</h5>
                                    </div>
                                </div>
                            </template>
                        </v-container>
                    </template>
                </div><!--col-->
            </div><!--form-group-->
        </div>
    </v-form>
</template>

<script>


import validation_rules from "../../../../mixin/validation_rules";
import Tooltip from "../../../../../shared/components/Tooltip.vue";
import Loading from "../shared/LoadingRow.vue";
import DatastreamsLoading from "./partials/DatastreamsLoading.vue";
export default {
    name: "ActivationDataStreams",
    components: {DatastreamsLoading, Loading, Tooltip},
    props: {
        isScheduler: Boolean,
        step: Number
    },
    mixins: [validation_rules],
    data: () => ({
        opened_panels: [],
        default_selection: true,
        export_all: false,
        visualize_all: false,
    }),
    methods: {
        async loadJsonFile (file) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader()
                fileReader.onload = event => resolve(JSON.parse(event.target.result))
                fileReader.onerror = error => reject(error)
                fileReader.readAsText(file)
            })
        },
        fieldRegexValidation(regexString, index, section, data_stream = null) {
            let fieldValue = undefined
            if (section === 'audience') {
                fieldValue = this.$store.getters['ActivateAudienceStore/getAudienceInputByIndex'](index)
            } else if (section === 'data_stream') {
                fieldValue = this.$store.getters['ActivateAudienceStore/getDataStreamInputByIndex']({
                    index: index,
                    data_stream: data_stream
                })
            } else {
                return true
            }

            let regex = new RegExp(regexString)
            if (fieldValue === undefined) {
                return true
            } else {
                return regex.test(fieldValue) || 'Invalid format'
            }
        },
        fieldRegexMacrosValidation(data_stream_index, input_index) {
            let input_status = true
            let regexp = "\{(.*?)\}";
            let folder_prefix = this.$store.getters['ActivateAudienceStore/getDataStreamInputByIndex']({
                data_stream: data_stream_index,
                index: input_index
            })
            let allowed_macros = this.$store.getters['ActivateAudienceStore/getDataStreamCustomDeliveryData'](data_stream_index).custom_macros
            let macros_found = [...folder_prefix.matchAll(regexp)];

            if (macros_found.length) {
                macros_found.forEach(item => {
                    if (!allowed_macros.includes(item[1])) {
                        input_status = "{" + item[1] + "}" + " macro is not available"
                    }
                })
            }

            return input_status
        },
        serviceAccountFileToJson(ds_index, file) {
            if (file.type === "application/json") {
                let tmp_credentials = this.loadJsonFile(file)
                tmp_credentials.then(credentials => {
                    this.$store.commit('ActivateAudienceStore/SET_DATASTREAM_JSON_SERVICE_ACCOUNT', {
                        data_stream: ds_index,
                        service_account: credentials
                    })
                })
            } else {
                this.$toast.open({
                    message: 'Invalid JSON format. Please fix it and re-upload it.',
                    type: "error",
                })

                return null
            }
        },
        open_docs() {
            window.open(this.docs_url, '_blank')
        },
        updateDataStreamInputValue(ds_index, input_index, value) {
            this.$store.commit('ActivateAudienceStore/SET_DATASTREAMS_INPUTS_BY_INDEX', {
                data_stream: ds_index,
                input: input_index,
                value: value
            })
        },
        getDataStreamInputValue(ds_index, input_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamInputByIndex']({
                data_stream: ds_index,
                index: input_index
            })
        },
        getDataStreamServiceAccountFile(ds_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamServiceAccountFile'](ds_index)
        },
        updateDataStreamStatusValue(ds_index, value) {
            this.$store.commit('ActivateAudienceStore/SET_DATASTREAMS_STATUS_BY_INDEX', {
                data_stream: ds_index,
                value: value
            })
        },
        updateDataStreamVisualizingStatusValue(ds_index, value) {
            this.$store.commit('ActivateAudienceStore/SET_DATASTREAMS_VISUALIZING_STATUS_BY_INDEX', {
                data_stream: ds_index,
                value: value
            })
        },
        getDataStreamStatusValue(ds_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamStatus'](ds_index)
        },
        getDataStreamVisualizingStatusValue(ds_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamVisualizingStatus'](ds_index)
        },
        getDataStreamCompressionType(ds_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamCompressionType'](ds_index)
        },
        updateDataStreamCompressionType(ds_index, value) {
            this.$store.commit('ActivateAudienceStore/SET_DATASTREAMS_COMPRESSION_TYPE_BY_INDEX', {
                data_stream: ds_index,
                value: value
            })
        },
        getDataStreamCustomDeliveryData(ds_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamCustomDeliveryData'](ds_index)
        },
        getDataStreamCredentials(ds_index) {
            return this.$store.getters['ActivateAudienceStore/getDataStreamServiceAccount'](ds_index)
        },
        updateDataStreamCredentials(ds_index, event) {
            this.serviceAccountFileToJson(ds_index, event)
            this.$store.commit('ActivateAudienceStore/SET_DATASTREAM_SERVICE_ACCOUNT_FILE', {
                data_stream: ds_index,
                service_account: event
            })
        },
        validateForm() {
            let current_step = this.step
            if (this.$refs['step_' + current_step].validate()) {
                if (this.isScheduler) {
                    return true
                } else {
                    if (this.$store.getters['ActivateAudienceStore/getDataStreamsDeliveryData'].length) {
                        this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
                    } else {
                        return false
                    }
                }
            }
        },
        exportAllDataStreams(value) {
            this.$store.getters['ActivateAudienceStore/getDataStreamsOptions'].forEach((data_stream, ds_index) => {
                this.updateDataStreamStatusValue(ds_index, value)
            })
        },
        visualizeAllDataStreams(value) {
            this.$store.getters['ActivateAudienceStore/getDataStreamsOptions'].forEach((data_stream, ds_index) => {
                this.updateDataStreamStatusValue(ds_index, value)
            })

            this.$store.getters['ActivateAudienceStore/getDataStreamsOptions'].forEach((data_stream, ds_index) => {
                if (data_stream.is_visualizing_available) {
                    this.updateDataStreamVisualizingStatusValue(ds_index, value)
                }
            })
        }
    },
    created() {
        //
    },
    mounted() {
        if (this.$store.getters['ActivateAudienceStore/getStepStatus']) {
            if (this.$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes('anonymized')) {
                this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
            } else {
                this.$store.dispatch('ActivateAudienceStore/getDataStreams')
            }
        }
    },
    computed: {
        partner: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getActivationPartner']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_ACTIVATION_PARTNER', value)
            }
        },
        is_datastreams_available: function () {
            return !!this.$store.getters['ActivateAudienceStore/getDataStreamsOptions'].length;
        },
        is_loading_completed: function () {
            return this.$store.getters['ActivateAudienceStore/getDataStreamsLoadingStatus']
        },
        get_step_string() {
            return "step_" + this.step
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>